

//  for currency change
export const formatCurrency = (value, symbol) => {
    return `${symbol}${value.toFixed(2)}`;
};